import { TEST_IDS } from '@va/constants';
import { CloseIconWithCircle } from '@va/icons';
import { Button, fontWeights, GrayGradientDivider, Heading5 } from '@va/ui/design-system';
import classNames from 'classnames';
import { ReactNode } from 'react';

const ModalHeader = ({
  title,
  onClose,
  className,
  closeIcon,
  titleClassName,
  hideDivider,
}: {
  title: string | ReactNode;
  onClose: () => void;
  className?: string;
  closeIcon?: ReactNode;
  titleClassName?: string;
  hideDivider?: boolean;
}) => {
  return (
    <>
      <div className={classNames('flex justify-between items-center py-15px px-18px', className)}>
        <Heading5 weight={fontWeights.semibold} className={titleClassName} colorClassName={'text-text-primary'}>
          {title}
        </Heading5>
        <Button
          data-testid={TEST_IDS.generic.buttons.closeModal}
          color='quinary'
          icon={() => closeIcon ?? <CloseIconWithCircle />}
          onClick={onClose}
        />
      </div>
      {!hideDivider && <GrayGradientDivider />}
    </>
  );
};

export { ModalHeader };
